module.exports = __webpack_public_path__ + "4b07683a3c129b75608aeb672541af5d.svg";